import { render } from "./DialogTeacherDetail.vue?vue&type=template&id=0ac6859b&scoped=true"
import script from "./DialogTeacherDetail.vue?vue&type=script&lang=js"
export * from "./DialogTeacherDetail.vue?vue&type=script&lang=js"

import "./DialogTeacherDetail.vue?vue&type=style&index=0&id=0ac6859b&lang=scss&scoped=true"
import "./DialogTeacherDetail.vue?vue&type=style&index=1&id=0ac6859b&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-四川职业技术学院门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac6859b"]])

export default __exports__